import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=65cc4b06&scoped=true&"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIcon.vue?vue&type=style&index=0&id=65cc4b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cc4b06",
  null
  
)

export default component.exports